module.exports = __webpack_public_path__ + "static/media/25.51c8f381.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shirts/25.png
// module id = 1464
// module chunks = 0